import { Paper, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';

export type MetricStripItem = {
  label: ReactNode;
  value: ReactNode;
  tone?: 'neutral' | 'primary' | 'warning';
};

export type MetricStripProps = {
  items: readonly MetricStripItem[];
  contained?: boolean;
};

export function MetricStrip({ items, contained = false }: MetricStripProps) {
  const content = (
    <Stack direction="row" sx={{ px: contained ? { xs: 1.5, md: 2.25 } : 3, py: contained ? 1.5 : 1.25, borderBottom: contained ? 0 : 1, borderColor: 'divider', bgcolor: designTokens.color.canvas, overflowX: contained ? 'hidden' : 'auto' }}>
      {items.map((item, index) => (
        <Stack key={index} direction={contained ? { xs: 'column', sm: 'row' } : 'row'} sx={{ flex: contained ? '1 1 0' : undefined, alignItems: contained ? { xs: 'flex-start', sm: 'baseline' } : 'baseline', minWidth: contained ? 0 : 150, pl: index ? { xs: 1.25, sm: 2 } : 0, ml: index ? { xs: 1.25, sm: 2 } : 0, borderLeft: index ? 1 : 0, borderColor: 'divider' }}>
          <Typography variant="caption" color="text.secondary" sx={{ mr: { sm: 1 }, lineHeight: 1.25, whiteSpace: { sm: 'nowrap' } }}>{item.label}</Typography>
          <Typography variant="body1" sx={{ fontWeight: 750, color: item.tone === 'warning' ? 'warning.dark' : item.tone === 'primary' ? 'primary.main' : 'text.primary', fontVariantNumeric: 'tabular-nums' }}>{item.value}</Typography>
        </Stack>
      ))}
    </Stack>
  );
  return contained
    ? <Paper variant="outlined" sx={{ overflow: 'hidden', borderRadius: designTokens.radius.surface, boxShadow: designTokens.shadow.surface }}>{content}</Paper>
    : content;
}
